/**
 * Utility functions for managing dynamic favicon
 */

/**
 * Update the favicon with a new URL
 * @param {string} faviconUrl - The URL of the new favicon
 * @param {string} type - The MIME type of the favicon (default: 'image/x-icon')
 */

import { config } from '../config/env';
export const updateFavicon = (faviconUrl, type = 'image/x-icon') => {
  try {
    // Remove any existing favicon links
    const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
    existingFavicons.forEach(favicon => favicon.remove());
    
    // Create a new link element for the favicon
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = type;
    link.href = faviconUrl;
    
    // Add the new favicon to the document head
    document.head.appendChild(link);
    
    console.log('Favicon updated successfully:', faviconUrl);
    return true;
  } catch (error) {
    console.error('Failed to update favicon:', error);
    return false;
  }
};

/**
 * Set the favicon to the business logo ICO
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const setBusinessFavicon = async () => {
    
    const icoUrl = config.appIconIco;
    
    return updateFavicon(icoUrl, 'image/x-icon');
  
};